export default __webpack_public_path__ + "static/media/lock-icon.0ef66081.svg";